export default "__VITE_ASSET__jieo7ugg__"